// extracted by mini-css-extract-plugin
export default {"logoWrapper":"AppLogo_logoWrapper__JaBqi","logo":"AppLogo_logo__JhktJ","subtitle":"AppLogo_subtitle__YmT4U"};